// import { stringify as stringifyQs } from "qs";

import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

import {
    ActiveTab,
    BulkAction,
    Dialog,
    Filters,
    Pagination,
    SingleAction,
    Sort,
    TabActionDialog
  } from "../types";
  
const countriesSection = '/country/';
export const countrieListPath = countriesSection;

export enum CountryListUrlFiltersEnum{
    enable = "enable",
    query = "query"
}

export enum CountryListUrlSortField{
    name = "name",
    isoTwoCode = "isoTwoCode",
    isoThreeCode = "isoThreeCode",
    isoNumberCode = "isoNumberCode",
    displayOrder = "displayOrder",
    regionsCount = "regionsCount",
}

export type CountryListUrlSort = Sort<CountryListUrlSortField>

export type CountryListUrlFilters = Filters<
  CountryListUrlFiltersEnum
>;

export type CountryListUrlDialog = "remove" | TabActionDialog | "unenable" |"enable";


export type CountryListUrlQueryParams = ActiveTab &
CountryListUrlFilters &
CountryListUrlSort &
BulkAction &
Dialog<CountryListUrlDialog> &
Pagination;

export const countryListUrl = (params?: CountryListUrlQueryParams) =>
countrieListPath + "?" + stringifyQs(params);

export type CountryUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values";
  

export type CountryAddUrlDialog =
| "add-value"
| "edit-value"
| "remove-value"
| "remove-values";

export type CountryAddUrlQueryParams = Dialog<CountryAddUrlDialog> & SingleAction;

export const countryAddPath = urlJoin(countriesSection, "add");

export const countryAddUrl = (params?: CountryAddUrlQueryParams) =>
    countryAddPath + "?" + stringifyQs(params);

export const countryPath = (id: string) => urlJoin(countriesSection, id);

export type CountryUrlQueryParams = BulkAction &
  Dialog<CountryUrlDialog> &
  SingleAction;

export const countryUrl = (id: string, params?: CountryUrlQueryParams) =>
countryPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
